import React, {useEffect, useState} from "react";
import {Alert, Button, Card, Divider, Empty, Form, Input, InputNumber, message, Popconfirm, Spin, Table} from "antd";
import {DeleteOutlined, LeftOutlined, PlusOutlined, SaveOutlined} from "@ant-design/icons";
import {useNavigate, useParams} from "react-router-dom";
import {getById, update} from "../../http/BonusRuleApi";
import {updateStudent} from "../../http/UserApi";

export default function EditBonusRule() {

    const navigate = useNavigate();
    const goBack = () => navigate(-1);
    const params = useParams();

    const [rules, setRules] = useState([]);
    const [ruleName, setRuleName] = useState('');

    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [alertSuccessVisible, setAlertSuccessVisible] = useState(false);
    const [alertErrorVisible, setAlertErrorVisible] = useState(false);

    const sortRules = (arr) =>
        [...arr].sort((a, b) => (a.minSum || 0) - (b.minSum || 0));

    const loadRules = async () => {
        setLoading(true);
        await getById(localStorage.getItem('token'), params.id).then(
            response => {
                if (response.data != null) {
                    const data = response.data;
                    if (data && data.config) {
                        setRules(sortRules(JSON.parse(data.config)));
                        setRuleName(data.name)
                    } else {
                        setRules([]);
                        setRuleName('');
                    }
                }
                setLoading(false);
            }
        ).catch(
            error => {
                console.log(error)
            }
        );
    };

    const saveRules = async () => {
        if (!ruleName.trim()) {
            message.warning('Введите название набора правил');
            return;
        }
        if (rules.length === 0) {
            message.warning('Добавьте хотя бы одно правило');
            return;
        }

        setSaving(true);
        await update(params.id, ruleName, JSON.stringify(rules), localStorage.getItem('token')).then(
            response => {
                loadRules()
                setAlertSuccessVisible(true);
            }).catch(
            error => {
                setAlertErrorVisible(true);
                console.log(error)
            }
        ).finally(() => {
                setSaving(false);
            }
        )
    };

    const addRule = () => {
        const newRule = {minSum: 0, bonus: 0};
        setRules(sortRules([...rules, newRule]));
    };

    const updateRule = (index, field, value) => {
        const updatedRules = [...rules];
        updatedRules[index] = {...updatedRules[index], [field]: value};
        setRules(updatedRules);

        clearTimeout(window.__sortTimer);
        window.__sortTimer = setTimeout(() => {
            setRules(prev => sortRules(prev));
        }, 800);
    };

    const deleteRule = (index) => {
        const updatedRules = rules.filter((_, i) => i !== index);
        setRules(updatedRules);
    };

    const handleSuccessClose = () => {
        setAlertSuccessVisible(false);
    };

    const handleErrorClose = () => {
        setAlertErrorVisible(false);
    };

    const columns = [
        {
            title: 'Минимальная сумма (₽)',
            dataIndex: 'minSum',
            key: 'minSum',
            render: (value, record, index) => (
                <InputNumber
                    value={value}
                    onChange={(val) => updateRule(index, 'minSum', val)}
                    min={0}
                    step={500}
                    style={{width: '100%'}}
                    placeholder="Введите сумму"
                />
            )
        },
        {
            title: 'Бонус',
            dataIndex: 'bonus',
            key: 'bonus',
            render: (value, record, index) => (
                <InputNumber
                    value={value}
                    onChange={(val) => updateRule(index, 'bonus', val)}
                    min={0}
                    step={100}
                    style={{width: '100%'}}
                    placeholder="Введите бонус"
                />
            )
        },
        {
            title: '',
            key: 'actions',
            align: 'center',
            render: (_, __, index) => (
                <Button
                    danger
                    icon={<DeleteOutlined/>}
                    onClick={() => deleteRule(index)}
                />
            )
        }
    ];

    useEffect(() => {
        loadRules();
    }, []);

    return (
        <div style={{minHeight: '100vh'}}>
            <Button onClick={goBack} style={{margin: '1vw'}}>
                <LeftOutlined/> Назад
            </Button>

            <div style={{
                minHeight: '100vh',
                display: "flex",
                justifyContent: "center"
            }}>
                <div style={{width: '90%', maxWidth: 900}}>
                    <Divider>Редактирование набора бонусных правил</Divider>

                    <Card>
                        <Form layout="vertical">
                            <Form.Item
                                label="Название набора правил"
                                required
                                validateStatus={ruleName ? '' : 'error'}
                                help={ruleName ? '' : 'Введите название'}
                            >
                                <Input
                                    value={ruleName}
                                    onChange={(e) => setRuleName(e.target.value)}
                                    placeholder="Введите название"
                                />
                            </Form.Item>

                            <div style={{
                                display: 'flex',
                                gap: '8px',
                                marginBottom: '16px'
                            }}>
                                <Button
                                    icon={<PlusOutlined/>}
                                    onClick={addRule}
                                >
                                    Добавить правило
                                </Button>
                                <Button
                                    type="primary"
                                    icon={<SaveOutlined/>}
                                    onClick={saveRules}
                                    loading={saving}
                                >
                                    Сохранить
                                </Button>
                            </div>

                            {loading ? (
                                <div style={{display: "flex", justifyContent: "center", padding: '40px'}}>
                                    <Spin/>
                                </div>
                            ) : (
                                <Table
                                    dataSource={rules.map((rule, index) => ({...rule, key: index}))}
                                    columns={columns}
                                    pagination={false}
                                    size="middle"
                                    bordered
                                    locale={{
                                        emptyText: (
                                            <Empty
                                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                description="Нет правил"
                                            />
                                        )
                                    }}
                                />
                            )}
                        </Form>

                        {alertSuccessVisible && (
                            <Alert message="Успешно сохранено" type="success" closable
                                   afterClose={handleSuccessClose}
                                   style={{marginTop: '1vw',}}/>
                        )}
                        {alertErrorVisible && (
                            <Alert message="Ошибка сохранения" type="error" closable
                                   afterClose={handleErrorClose}
                                   style={{marginTop: '1vw',}}/>
                        )}
                    </Card>
                </div>
            </div>
        </div>
    );
}